






















import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { UserModel } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "LoginForm",
		components: { ButtonList }
	})
export default class LoginForm extends ParticaBaseForm<UserModel> {
	private emailconfig =
		{
			props: { name: "email", placeholder: "Enter email", label: "Email", } as FormFieldProps,
			rules: { required: true, email: true } as FormFieldRules
		} as IFormField;

	private passwordconfig =
		{
			props: { name: "password", placeholder: "Enter password", label: "Password", } as FormFieldProps,
			rules: { required: true, max: 100, min: 6, } as FormFieldRules
		} as IFormField;

}
